import { ReactNode } from 'react';
import { Button, type ButtonProps } from '@/components/ui/button';
import { cn } from '@/lib/utils/cn';

export function PrimaryButton({ className, ...props }: ButtonProps) {
  return <Button variant="primary" className={className} {...props} />;
}

export function SecondaryButton({ className, ...props }: ButtonProps) {
  return <Button variant="neutral" className={className} {...props} />;
}

// Red action button for confirm/book actions
export function DangerButton({ className, ...props }: ButtonProps) {
  return <Button variant="secondary" className={className} {...props} />;
}

export function OutlineButton({ className, ...props }: ButtonProps) {
  return <Button variant="outline" className={className} {...props} />;
}

export function GhostButton({ className, ...props }: ButtonProps) {
  return <Button variant="ghost" className={className} {...props} />;
}

export function LinkButton({ className, ...props }: ButtonProps) {
  return <Button variant="link" className={className} {...props} />;
}

interface IconButtonProps extends ButtonProps {
  icon: ReactNode;
}

export function IconButton({ icon, className, ...props }: IconButtonProps) {
  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn('rounded-lg', className)}
      {...props}
    >
      {icon}
    </Button>
  );
}
